import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthLoading, setIsAuthLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const roles = localStorage.getItem("roles");
    const email = localStorage.getItem("email");
    const id = localStorage.getItem("id");
    const tenantId = localStorage.getItem("tenant_id");
    const sipName = localStorage.getItem("sip_name");
    const mustResetPassword = localStorage.getItem("must_reset_password") === "true";

    if (token) {
      setUser({
        token,
        email,
        id,
        tenantId,
        sipName,
        roles: roles ? JSON.parse(roles) : [],
        mustResetPassword,
      });
    }

    setIsAuthLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const formData = new URLSearchParams();
      formData.append("email", email);
      formData.append("password", password);

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData,
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.detail || "Login failed");

      localStorage.setItem("token", data.access_token);
      localStorage.setItem("roles", JSON.stringify(data.user.roles || []));
      localStorage.setItem("email", data.user.email);
      localStorage.setItem("id", data.user.id);
      localStorage.setItem("tenant_id", data.user.tenant_id || "");
      localStorage.setItem("sip_name", data.user.sip_name || "");
      localStorage.setItem("must_reset_password", data.user.must_reset_password ? "true" : "false");

      setUser({
        token: data.access_token,
        id: data.user.id,
        email: data.user.email,
        tenantId: data.user.tenant_id || "",
        sipName: data.user.sip_name || "",
        roles: data.user.roles || [],
        mustResetPassword: !!data.user.must_reset_password,
      });

      return { success: true, redirectPath: data.redirect_path || null };
    } catch (error) {
      console.error("Login error:", error);
      return { success: false, redirectPath: null };
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("roles");
    localStorage.removeItem("email");
    localStorage.removeItem("id");
    localStorage.removeItem("tenant_id");
    localStorage.removeItem("sip_name");
    localStorage.removeItem("must_reset_password");
    localStorage.removeItem("original_identity");
    localStorage.removeItem("impersonated_user");
    localStorage.removeItem("real_user");
    setUser(null);
  };

  // Called once /change_password succeeds so the forced-reset redirect in
  // PrivateRoute.js stops firing without requiring a fresh login.
  const clearMustResetPassword = () => {
    localStorage.setItem("must_reset_password", "false");
    setUser((u) => (u ? { ...u, mustResetPassword: false } : u));
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, isAuthLoading, clearMustResetPassword }}>
      {children}
    </AuthContext.Provider>
  );
};